type Listener<T> = (value: T, prev: T) => void;

export class Store<T> {
  private value: T;
  private listeners = new Set<Listener<T>>();
  constructor(initial: T) {
    this.value = initial;
  }
  get(): T {
    return this.value;
  }
  set(next: T | ((prev: T) => T)): void {
    const prev = this.value;
    const val = typeof next === 'function' ? (next as (p: T) => T)(prev) : next;
    if (val === prev) return;
    this.value = val;
    for (const l of this.listeners) l(val, prev);
  }
  subscribe(l: Listener<T>): () => void {
    this.listeners.add(l);
    return () => this.listeners.delete(l);
  }
}

import type { Manifest, Route } from './types.js';

export interface AppState {
  manifest: Manifest | null;
  route: Route;
  error: string | null;
}

export const app = new Store<AppState>({
  manifest: null,
  route: { name: 'home' },
  error: null,
});
